import { createContext } from 'react';

/** @type {import('react').Context<AdminStore>} */
const AdminStoreContext = createContext();

export default AdminStoreContext;
